import React, { useEffect, useState } from "react";
import { Button, Form, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";

import { useQueryClient } from "react-query";
import toast from "react-hot-toast";
import { Spin } from "antd";
import { Row, Col } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { file } from "jszip";
import { createTypeInspection, updateTypeInspection } from "../services/typeApi";
import { FilePond } from "react-filepond";
import { uploadImage } from "../../Media/services/mediaApi";
const AddEditType = ({ modal, setModal, toggle, selectedType }) => {
  const { t } = useTranslation(); 
  const queryClient = useQueryClient();
  const [isLoading, setIsLoading] = useState(false);
  const [image, setImage] = useState(null);
  const validationSchema = Yup.object().shape({
    name: Yup.string().required(t("types.nameRequired")),
    description: Yup.string().required(t("types.descriptionRequired")),
    //fileName: Yup.string().required(t("types.categoryRequired")),
  });
  const category="inspection Type";
  const handlePhotoFileUpdate = (fileItems) => {
    setImage(fileItems.length > 0 ? fileItems[0].file : null);
  };
  const initialValues = selectedType ? {
    name: selectedType.name,
    description:selectedType.description,
    fileName: selectedType.fileName  ,
  } : {
    name: "",
    description: "",
    fileName: "",
  };
  const modalTitle = selectedType ? t("types.modalTitleEdit") : t("types.modalTitleAdd");
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        // Uploader l'image d'abord, si elle est présente
        let fileName = values.fileName;
        if (image) {
         const response  = await uploadImage(category, image); 
         fileName= response?.name // On récupère le fileName de l'image
        }
        if (selectedType) {
          await updateTypeInspection(selectedType?.id, {
            name: values.name,
            description: values.description,
            fileName: values.fileName,
          });
          toast.success(t("types.statusUpdatedSuccess"));
        } else {
          await createTypeInspection({
            name: values.name,
            description: values.description,
            fileName: values.fileName,
          });
          toast.success(t("types.statusCreatedSuccess"));
        }
        await queryClient.invalidateQueries("types");
        toggle();
        formik.resetForm();
      } catch (error) {
        if (selectedType) {
          console.error("Error updating status:", error?.message || error);
          toast.error(`${t("types.errorUpdatingStatus")} ${error?.message || error}`);
        } else {
          console.error("Error creating status:", error?.message || error);
          toast.error(`${t("types.errorCreatingStatus")} ${error?.message || error}`);
        }
      } finally {
        setIsLoading(false);
      }
    },
  });

  useEffect(() => {
    formik.setValues(initialValues);
  }, [selectedType]);

  return (
    <Modal id="showModalClient" isOpen={modal} toggle={toggle} centered backdrop={"static"}>
      <ModalHeader className="bg-info-subtle p-3" toggle={toggle}>
        {modalTitle}
      </ModalHeader>
      <Form onSubmit={formik.handleSubmit}>
        <ModalBody>
             <Row>
            <Col md={12}>  
             {/* Champ Upload Image */}
          <div className="mb-3">
            <label htmlFor="fileName" className="form-label">{t("vehicleForm.uploadImage")}</label>
            <FilePond
                  file={image ?[image]:[]}
                  onupdatefiles={handlePhotoFileUpdate}
                  allowMultiple={false}
                  maxFiles={1}
                  name="fileName"
                  labelIdle='<span class="filepond--label-action">Parcourir</span> ou Glisser directement'
                  
                />

          
           
          </div>
          {formik.touched.image && formik.errors.image ? (
              <div className="text-danger">{formik.errors.image}</div>
            ) : null}</Col>
          </Row>
          
          {/* Name Field */}
          <div className="mb-3">
            <label htmlFor="name" className="form-label">
              {t("types.name")}
            </label>
            <input
              type="text"
              id="name"
              name="name"
              className="form-control"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.name}
              style={{ borderRadius: "20px" }}
            />
            {formik.touched.name && formik.errors.name && (
              <div className="text-danger">{formik.errors.name}</div>
            )}
          </div>

        

          {/* Description Field */}
          <div className="mb-3">
            <label htmlFor="description" className="form-label">
              {t("types.description")}
            </label>
            <textarea
              id="description"
              name="description"
              className="form-control"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.description}
              rows="4"
              style={{ borderRadius: "20px" }}
            />
            {formik.touched.description && formik.errors.description && (
              <div className="text-danger">{formik.errors.description}</div>
            )}
          </div>

        </ModalBody>
        <ModalFooter>
          <Button className="bordered-btn-light" color="light" onClick={() => setModal(false)}>
            {t("types.cancel")}
          </Button>

          <Button type="submit" className="bordered-btn" disabled={isLoading}>
            {isLoading ? <Spin size="small" /> : selectedType ? t("types.submitButtonEdit") : t("types.submitButtonAdd")}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default AddEditType;
